const emailRegex = /^(([a-z0-9+_-]\.?)+[a-z0-9+_-]|[a-z0-9])@[a-z0-9.-]+\.[a-z]{2,}$/i;

const validateEmail = (email: string) => emailRegex.test(email);

export { emailRegex, validateEmail };
